exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pl-loginform {\n    min-width: 200px;\n    max-width: 400px;\n    margin: auto;\n}\n\n.pl-loginform label {\n    min-width: 130px;\n    display: inline-block;\n}\n\n.pl-loginform input[type=text] {\n    width: 400px;\n    min-width: 200px; \n}\n\n.pl-loginform input[type=password] {\n    width: 400px;\n    min-width: 200px; \n}\n\n.pl-loginform input[type=submit] {\n    min-width: 100px;\n    float: right;\n}\n\nspan.clear { clear: both; display: block; }\n\n.pl-login-container {\n    color: white;\n    font-weight: bold;\n    background: rgba(104, 124, 126, 0.7);\n    padding-top: 10px;\n    padding-bottom: 10px;\n    width: 100%;\n    padding-left: 10px;\n    padding-right: 10px;\n    border-radius: 10px;\n}\n\n.pl-login-container form {\n    opacity: 1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main